import React, { useEffect } from 'react';
import { BiCodeCurly } from '@/components/react-icons/main';
import { FiPlay } from '@/components/react-icons/main/index.esm';
import { isRedactedHistoryValue } from '@shared/utils/isRedactedHistoryValue.js';
import copyToClipboard from '../../../lib/copyToClipboard';
import sendToast from '../../../lib/sendToast';
import setQuery from '../../../lib/setQuery';
import { setContextMenuListener } from '../../../redux/actions/uiActions/contextMenuActions';
import getReplayAvailability from '../workflowLogs/lib/getReplayAvailability';
import { findSpanContaining } from '../workflowLogs/lib/getReplayRangeModel';

const useLogStepsContextMenu = ({ allSteps, replayModel, activeLog }) => {
  useEffect(() => {
    const contextMenuConfig = {
      id: 'logSteps',
      route: '/workflows/',
      options: [
        {
          icon: <BiCodeCurly />,
          label: 'Copy cURL',
          disabled: false,
          selectors: ['.log-step'],
          onClick: (e) => {
            e.stopPropagation();
            const closest = e.target.closest('.log-step');
            const stepId = closest?.getAttribute('data-step-id');
            const step = allSteps.find((n) => n.stepId === stepId);
            const cUrl = step?.lastOutput?.response?.meta?.curl;
            if (cUrl && !isRedactedHistoryValue(cUrl)) {
              copyToClipboard(cUrl, { toast: true });
              return;
            }
            sendToast({ message: 'No cURL available for this step.' });
          }
        },
        {
          icon: <FiPlay />,
          label: 'Replay from this action',
          disabled: false,
          selectors: ['.log-step'],
          onClick: (e) => {
            e.stopPropagation();
            const availability = getReplayAvailability(activeLog);
            if (availability.disabled) {
              sendToast({ message: availability.title, duration: 6000 });
              return;
            }

            const closest = e.target.closest('.log-step');
            const stepId = closest?.getAttribute('data-step-id');
            const step = allSteps.find((n) => n.stepId === stepId);
            const span = replayModel?.spans?.find((n) => n.stepId === stepId) || (typeof step?.firstTime === 'number' ? findSpanContaining(replayModel?.spans, step.firstTime) : undefined);
            if (!span) {
              sendToast({ message: 'This step cannot be replayed.' });
              return;
            }
            setQuery({ replayMode: 'true', replayStart: span.start, replayEnd: replayModel.max });
          }
        }
      ]
    };
    setContextMenuListener(contextMenuConfig);
  }, [allSteps, replayModel, activeLog]);
};

export default useLogStepsContextMenu;
